import { NdmsResolverService } from "../../../../../shared/core/interfaces/ndmsResolverService";
import { Injectable } from "@angular/core";
import { ViewModelModelMappingService } from "../../../../../shared/core/services/view-model-model-mapping.service";
import { Router } from "@angular/router";
import { ToastService } from "../../../../../shared/core/services/toast.service";
import { ViewModelService } from "../../../../../shared/core/services/view-model.service";
import { LookupService } from "../../../../../shared/core/services/lookup.service";
import { FCCService } from "../../../api/services/fcc.service";
import QueryLocationsParams = FCCService.QueryLocationsParams;
import { LocationHistoryReportService } from "../../../api/services/location-history-report.service";
import { OperationModel } from "../../../api/models/operation-model";
import { FccModel } from "../../../api/models/fcc-model";
import { LocationModel } from "../../../api/models/location-model";
import { OperationService } from "../../../api/services/operation.service";
import { map } from "rxjs/operators";
import { LocationsMaintenanceService } from "../../../api/services/locations-maintenance.service";
import { FCCsMaintenanceService } from "../../../api/services/fccs-maintenance.service";
@Injectable()
export class CoreJpatsServices extends NdmsResolverService {

  constructor(private fccService: FCCService,
    private operationService: OperationService,
    private locationHistoryReportService: LocationHistoryReportService,
    private locationsMaintenanceService: LocationsMaintenanceService,
    private fccsMaintenanceService: FCCsMaintenanceService,
    private lookupService: LookupService,
    private router: Router,
    private toastService: ToastService,
    private viewModelService: ViewModelService,
    private viewModelModelMappingService: ViewModelModelMappingService) {
    super();
  }
  resolve(params: any): any {
    return undefined;
  }
  getLocationByKey(locationKey) {
    return this.fccService.GetLocationByKey(locationKey).pipe(map((res) => {
      return res.model;
    }));
  }
  getFccsByOperation(operationKey) {
    return this.operationService.GetOperationFccs(operationKey).pipe(map((res) => {
      return res;
    }));
  }
  getLocationsByOperation(operationKey) {
    return this.operationService.GetOperationLocations(operationKey).pipe(map((res) => {
      return res;
    }));
  }
  getLocationsByFcc(fccKey: string) {
    let params: QueryLocationsParams = {
      fccKey: fccKey,
      Page: 0
    };

    return this.fccService.QueryLocations(params).pipe(map((result) => {
      return result.model;
    }));
  }
  getAPOEFcc(fccKey: string) {

    return this.fccService.QueryFccAPOE({}).pipe(map((result) => {
      return result.model;
    }));
  }
  saveFcc(fcc) {
    return this.fccService.SaveAPOEFcc(fcc).pipe(map((result) => {
      return result.model;
    }));
  }
  SaveOperation(operationModel: OperationModel) {
    return this.operationService.Save(operationModel).pipe(map((res) => {
      return res;
    }));
  }

  GetOperations() {
    return this.operationService.Get().pipe(map((res) => {
      return res.model;
    }));
  }

  GetOperationPatientCount(operationModel: OperationModel) {
    return this.operationService.GetPatientCount(operationModel.key).pipe(map((res) => {
      return res;
    }));
  }

  GetFccPatientCount(fccModel: FccModel) {
    return this.fccsMaintenanceService.GetPatientCount(fccModel.fccKey).pipe(map((res) => {
      return res;
    }));
  }

  GetLocationPatientCount(locationModel: LocationModel) {
    return this.locationsMaintenanceService.GetPatientCount(locationModel.key).pipe(map((res) => {
      return res;
    }));
  }

  //fccKey?: string, operationKey?: string
  GetLocationHistoryReport(params) {

    return this.locationHistoryReportService.GetLocationHistoryReport(params).pipe(map((res) => {
      return JSON.parse(res.model);
    }));
  }
}
